import { render, staticRenderFns } from "./GroundStationRoutePanel.vue?vue&type=template&id=04996605&scoped=true"
import script from "./GroundStationRoutePanel.vue?vue&type=script&lang=js"
export * from "./GroundStationRoutePanel.vue?vue&type=script&lang=js"
import style0 from "./GroundStationRoutePanel.vue?vue&type=style&index=0&id=04996605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04996605",
  null
  
)

export default component.exports